<script>
    /*
    	ReferralUpdateSection.svelte

        This "single use" section is only used on the standalone ReferralUpdateScreen.
        Does not need some of the extra baggage that a ReferralSection needs.
    */

    import { onMount } from 'svelte';

    // TCARE components
    import ReferralQuestionSet from './ReferralQuestionSet.svelte';

    export let section;

    onMount(() => {
    })

    const setValue = (source, prop, value) => {
        // console.log('ReferralUpdateSection.setValue: ', source, prop, value);
        source[prop] = value;
        section = section;          // Svelte refresh - must do this
    }


</script>

<style>
    .ref-update-section {
        width: 100%;
        margin-bottom: 5px;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>


<!-- could just show the questions here without needing a comp -->
<div class="ref-update-section">
    <ReferralQuestionSet {section} {setValue} />
</div>
